import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Calendar = createSvgIcon(React.createElement("path", { d: "M18.605,4V1h-2v3h-8V1h-2v3h-6v20h24V4H18.605z M6.605,6h2h8h2h4v2h-20V6H6.605z M2.605,22V10h20v12H2.605z" }), 'Calendar');
export default Calendar;
